import editUserServices from "../services/edit-users/edit-users.service";

// History is returned newest first; only the latest entry counts, so an empty latest comment yields no reason.
export const getFlagReasonsByCustomer = async (customerIds: number[]): Promise<Map<number, string>> => {
    const reasons = new Map<number, string>();
    const uniqueIds = Array.from(new Set(customerIds.filter(id => id != null)));

    await Promise.all(uniqueIds.map(async (id) => {
        const history = await editUserServices.getFlagHistory(id);
        const latest = history[0];
        reasons.set(id, latest?.comments?.trim() ?? '');
    }));

    return reasons;
};
